<template>
  <section>
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-lg-12" v-scroll-reveal.reset="{ delay: 250 }">
          <div class="d-flex justify-content-between align-items-center">
            <h3>List Pre Order yang tersedia saat ini</h3>
            <a href>
              <router-link to="/listpo" class="primary" tag="h4">Lihat Semua</router-link>
            </a>
          </div>
        </div>
        <div
          class="col-xl-4 col-lg-9 col-md-10 mb-3 mb-sm-5 mt-3 mt-lg-5"
          v-for="listPO in preorder" v-bind:key="listPO.id" v-scroll-reveal.reset="{ delay: 300 }" >
          <div class="card card-body hover-box-shadow">
            <img
              src="assets/img/avatars/female-1.jpg"
              alt="Joshua Lapinsky profile image"
              class="avatar mt-md-n5 mb-3"
            />
            <div>
              <div class="text-muted mb-3">{{ listPO.seller }}, {{ listPO.location }}</div>
              <a href>
                <router-link to="/detailpo" tag="h4">{{ listPO.title }}</router-link>
              </a>
              <p
                style="font-size: 15px; color: #88919D; line-height: 1.2; margin-bottom: 18px;"
              >{{ listPO.description }}</p>
              <p class="primary lead mb-3">
                <strong>{{ listPO.price }}</strong>
              </p>

              <div class="d-flex justify-content-between align-items-center">
                <a href="#" class="badge badge-pill badge-info">Pre Order</a>
                <div class="text-small text-muted">{{ listPO.date }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PoSection",
  data: function() {
    return {
      preorder: [
        {
          id: 1,
          seller: 'Pipit Agustin',
          location: 'Surabaya',
          title: 'Open P.O oleh-oleh express khas Bali',
          description: 'Semua kemasan akan disinfectant dahulu kemasannya. (bukan makanannya ya)',
          price: 'Rp 15,000 - 100,000',
          date: '30 Hari Lagi',
          avatar: 'female-1.jpg'
        },
        {
          id: 2,
          seller: 'Pipit Agustin 2',
          location: 'Surabaya 2',
          title: 'Open P.O oleh-oleh express khas Bali 2',
          description: 'Semua kemasan akan disinfectant dahulu kemasannya. (bukan makanannya ya)',
          price: 'Rp 15,000 - 100,000',
          date: '30 Hari Lagi',
          avatar: 'female-2.jpg'
        },        
      ]
    } 
  }
};
</script>